import * as React from 'react';
import { Box, Grid, Link, Typography, useTheme } from '@mui/material';

import { ReactComponent as PolyChart1Svg } from 'assets/images/poly_chart_1.svg';

interface TopSubscribersProps {}

export const TopSubscribers: React.FC<TopSubscribersProps> = () => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          paddingY: 2,
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            lineHeight: 1.1,
          }}
        >
          Top Subscribers
        </Typography>

        <Typography
          variant="caption"
          color="textSecondary"
          sx={{
            lineHeight: 1.2,
            marginLeft: 1,
          }}
        >
          Monthly Views
        </Typography>

        <Link
          component="button"
          variant="subtitle2"
          onClick={() => {}}
          sx={{
            lineHeight: 1.2,
            marginLeft: 'auto',
          }}
        >
          See All
        </Link>
      </Box>

      <Box>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <Box
              sx={{
                height: 150,
                width: '100%',
                display: 'flex',
                backgroundColor: theme.palette.grey[200],
                flexDirection: 'column',
                justifyContent: 'flex-end',
                borderRadius: 1,
                paddingX: 3,
                paddingY: 2,
                position: 'relative',
              }}
            >
              <Typography variant="subtitle2" color="primary">
                ZONE #570336
              </Typography>
              <Typography variant="body2">Office, Lab, Storage</Typography>

              <Box
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 15,
                  color: theme.palette.primary.main,
                }}
              >
                <PolyChart1Svg />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box
              sx={{
                height: 150,
                width: '100%',
                display: 'flex',
                backgroundColor: theme.palette.grey[200],
                flexDirection: 'column',
                justifyContent: 'flex-end',
                borderRadius: 1,
                paddingX: 3,
                paddingY: 2,
                position: 'relative',
              }}
            >
              <Typography variant="subtitle2" color="primary">
                ZONE #570333
              </Typography>
              <Typography variant="body2">Office</Typography>

              <Box
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 15,
                  color: theme.palette.primary.main,
                }}
              >
                <PolyChart1Svg />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
